function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 9.5,
  cy: 9.5,
  r: 9,
  stroke: "#E5E7E7"
});

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#copy_svg__clip0)",
  stroke: "#AAAABD",
  strokeWidth: 1.3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("path", {
  d: "M12.92 8.74H9.5a.76.76 0 00-.76.76v3.42c0 .42.34.76.76.76h3.42c.42 0 .76-.34.76-.76V9.5a.76.76 0 00-.76-.76z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.22 11.02h-.38a.76.76 0 01-.76-.76V6.84a.76.76 0 01.76-.76h3.42a.76.76 0 01.76.76v.38"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "copy_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  transform: "translate(5.32 5.32)",
  d: "M0 0h9.12v9.12H0z"
})));

function SvgCopy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    fill: "none"
  }, props), _ref, _ref2, _ref3);
}

export default SvgCopy;